var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { "min-width": "1200px" } },
        [
          _c(
            "span",
            { staticClass: "title" },
            [
              _vm._v(" " + _vm._s(_vm.$t("SeaExport.DoorToDoorLoading")) + " "),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "red",
                    "font-weight": "lighter",
                    margin: "30px"
                  }
                },
                [
                  _vm._v(
                    "注：1、" +
                      _vm._s(
                        _vm.$t("SeaExport.SaveBusinessBeforeEnterMultiGate")
                      ) +
                      "；2、"
                  ),
                  _vm.job.dischargingPortDoor
                    ? _c("span", [
                        _vm._v(
                          "若需指定目的港运输公司，请维护运输公司字段，未维护时尾程商务会进行分配"
                        )
                      ])
                    : _vm._e()
                ]
              ),
              (_vm.job.lob === "SE" || _vm.job.lob === "AE") &&
              _vm.readonly &&
              _vm.showSync
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.exportSyncImport }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.job.multipleDischargingPickups,
                      expression: "job.multipleDischargingPickups"
                    }
                  ]
                },
                [
                  _vm.top.visible
                    ? _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "1",
                          "config-module": _vm.topConfigModuel,
                          "grid-options": _vm.top.gridOptions,
                          "column-defs": _vm.topColumnDefs,
                          "row-data": _vm.trucking
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.topGridApi = params.api
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              !_vm.isMaster && _vm.job.multipleDischargingPickups
                ? _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row operations",
                      staticStyle: { padding: "5px 0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cooperateEdit,
                              expression: "cooperateEdit"
                            }
                          ],
                          staticClass: "triggers"
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "2",
                                    type: "primary",
                                    disabled: _vm.readonly || !_vm.addEnable
                                  },
                                  on: { click: _vm.copyNewHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.copyAndAddPoItems")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "3",
                                    type: "primary",
                                    disabled: _vm.readonly || !_vm.addEnable
                                  },
                                  on: { click: _vm.addHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "4",
                                    type: "danger",
                                    disabled: _vm.readonly
                                  },
                                  on: { click: _vm.delHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm.job.multipleDischargingPickups ? _c("el-divider") : _vm._e(),
              _c(
                "el-form",
                {
                  staticClass: "inline-form",
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                no: "5.1",
                                disabled: _vm.readonly || _vm.action === "add"
                              },
                              on: { change: _vm.multiPickupsChangeHandler },
                              model: {
                                value: _vm.job.multipleDischargingPickups,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "multipleDischargingPickups",
                                    $$v
                                  )
                                },
                                expression: "job.multipleDischargingPickups"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("SeaExport.MultiDoors")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticClass: "inline-form",
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("label", { staticStyle: { width: "55px" } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "118px" },
                        attrs: {
                          no: "6",
                          value: _vm.truckingInfo.quantity || undefined,
                          disabled: _vm.readonly,
                          min: 0,
                          max: 99999,
                          precision: 0,
                          "controls-position": "right"
                        },
                        on: {
                          input: function(val) {
                            _vm.truckingInfo.quantity = val
                          }
                        }
                      }),
                      _c("label", { staticStyle: { width: "55px" } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "118px" },
                        attrs: {
                          no: "7",
                          value: _vm.truckingInfo.weight || undefined,
                          disabled: _vm.readonly,
                          min: 0,
                          max: 99999,
                          precision: 3,
                          "controls-position": "right"
                        },
                        on: {
                          input: function(val) {
                            _vm.truckingInfo.weight = val
                          }
                        }
                      }),
                      _c("label", { staticStyle: { width: "55px" } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "118px" },
                        attrs: {
                          no: "8",
                          value: _vm.truckingInfo.cubage || undefined,
                          disabled: _vm.readonly,
                          min: 0,
                          max: 99999,
                          precision: 3,
                          "controls-position": "right"
                        },
                        on: {
                          input: function(val) {
                            _vm.truckingInfo.cubage = val
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.job.multipleDischargingPickups
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          staticStyle: { "margin-left": "30px" },
                          attrs: { label: "S/O No", "label-width": "100px" }
                        },
                        [
                          _c("so-no-selector", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              "so-no": _vm.soNo,
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.truckingInfo.soNo,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "soNo", $$v)
                              },
                              expression: "truckingInfo.soNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "trucking-form" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "140px",
                        "label-position": "left"
                      }
                    },
                    [
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: {
                                label: _vm.$t("SeaExport.HaulageCompany")
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticStyle: {
                                  width: "400px",
                                  display: "inline-block"
                                },
                                attrs: {
                                  no: "9",
                                  disabled: _vm.readonly,
                                  "method-params": {
                                    truckCmp: true,
                                    active: true
                                  },
                                  "default-value":
                                    _vm.truckingInfo.carryingCmp || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.truckingInfo.carryingCmp = p.value || 0
                                    _vm.carryingCmpChangeHandler()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: {
                                label: _vm.$t("SeaExport.HaulageContactPerson")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    no: "10",
                                    placeholder: _vm.readonly
                                      ? ""
                                      : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                    "allow-create": true,
                                    clearable: true,
                                    filterable: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.carryingContactsChangeHandler(
                                        false,
                                        false
                                      )
                                    },
                                    blur: _vm.selectContactBlur
                                  },
                                  model: {
                                    value: _vm.truckingInfo.driver,
                                    callback: function($$v) {
                                      _vm.$set(_vm.truckingInfo, "driver", $$v)
                                    },
                                    expression: "truckingInfo.driver"
                                  }
                                },
                                _vm._l(_vm.carryingContacts, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.contactPerson,
                                      value: item.contactPerson
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("CargoMsg.EstimatedDeliveryDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "loadingDate",
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "11",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "loadingDate",
                                  null,
                                  true,
                                  true,
                                  _vm.truckingInfo
                                )
                              }
                            },
                            model: {
                              value: _vm.truckingInfo.loadingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                              },
                              expression: "truckingInfo.loadingDate"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: {
                                label: _vm.$t("Warehouse.Driver"),
                                disabled: _vm.txtEditEable
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: { no: "12" },
                                model: {
                                  value: _vm.truckingInfo.driverName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.truckingInfo,
                                      "driverName",
                                      $$v
                                    )
                                  },
                                  expression: "truckingInfo.driverName"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.travelTime") }
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "105px" },
                            attrs: {
                              no: "13",
                              min: 0,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.truckingInfo.travelHour,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "travelHour", $$v)
                              },
                              expression: "truckingInfo.travelHour"
                            }
                          }),
                          _c("span", { staticStyle: { margin: "10px" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.Hour")))
                          ]),
                          _c("el-input-number", {
                            staticStyle: { width: "100px" },
                            attrs: {
                              no: "14",
                              min: 0,
                              max: 59,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.truckingInfo.travelMinute,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "travelMinute", $$v)
                              },
                              expression: "truckingInfo.travelMinute"
                            }
                          }),
                          _c("span", { staticStyle: { margin: "10px" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.Minute")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.DoorContactPerson")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { no: "15" },
                            model: {
                              value: _vm.truckingInfo.doorMan,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                              },
                              expression: "truckingInfo.doorMan"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.DoorAddress") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { no: "16", type: "textarea", rows: 3 },
                            model: {
                              value: _vm.truckingInfo.doorAddr,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                              },
                              expression: "truckingInfo.doorAddr"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.ZIP") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { no: "zipCode" },
                            model: {
                              value: _vm.truckingInfo.zipCode,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "zipCode", $$v)
                              },
                              expression: "truckingInfo.zipCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: {
                                    label: _vm.$t("Pricing.BelongingCity")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "160px" },
                                    attrs: {
                                      no: "17",
                                      disabled: _vm.readonly,
                                      "tag-name":
                                        _vm.$store.getters.language === "zh"
                                          ? "chineseName"
                                          : "englishName",
                                      "tag-value": "code",
                                      cache: false,
                                      filterable: "",
                                      "default-value":
                                        _vm.truckingInfo.cityCode,
                                      "static-options": _vm.cityList,
                                      placeholder: _vm.$t(
                                        "SeaExport.PleaseSelect"
                                      )
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.truckingInfo.cityCode = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form",
                                {
                                  attrs: {
                                    "label-width": "100px",
                                    "label-position": "left"
                                  }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "custom",
                                      attrs: {
                                        label: _vm.$t("Warehouse.PalletSum")
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "140px" },
                                        attrs: {
                                          no: "18",
                                          value: _vm.truckingInfo.palletSum,
                                          disabled: _vm.readonly,
                                          min: 0,
                                          max: 999999999999,
                                          precision: 0,
                                          controls: false
                                        },
                                        on: {
                                          input: function(val) {
                                            _vm.truckingInfo.palletSum =
                                              val || 0
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PalletDetails")
                          }
                        },
                        [
                          _c("cargo-textarea", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "agentInformation",
                              type: "textarea",
                              row: 3
                            },
                            model: {
                              value: _vm.truckingInfo.palletDetail,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "palletDetail", $$v)
                              },
                              expression: "truckingInfo.palletDetail"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PalletDimensions")
                          }
                        },
                        [
                          _c("cargo-textarea", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "agentInformation",
                              type: "textarea",
                              row: 3
                            },
                            model: {
                              value: _vm.truckingInfo.palletSize,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "palletSize", $$v)
                              },
                              expression: "truckingInfo.palletSize"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "PO" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "po",
                              disabled: _vm.readonly,
                              "filter-chars": false,
                              type: "textarea",
                              rows: 3
                            },
                            model: {
                              value: _vm.truckingInfo.po,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "po", $$v)
                              },
                              expression: "truckingInfo.po"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.BillExchangeAgent")
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticStyle: {
                                  width: "400px",
                                  display: "inline-block"
                                },
                                attrs: {
                                  no: "exChangeAgent",
                                  "method-params": {
                                    bookingAgent: true,
                                    active: true
                                  },
                                  "default-value":
                                    _vm.truckingInfo.exChangeAgent || ""
                                },
                                on: { change: _vm.onExChangeAgentChange }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.HaulageNo") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "158px" },
                            attrs: {
                              no: "19",
                              disabled:
                                _vm.readonly || !!_vm.truckingInfo.carFormUuid
                            },
                            on: {
                              change: function($event) {
                                _vm.checkTruckOrderNo()
                                _vm.refreshTopGrid()
                              }
                            },
                            model: {
                              value: _vm.truckingInfo.truckOrderNo,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "truckOrderNo", $$v)
                              },
                              expression: "truckingInfo.truckOrderNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.HaulageCharge") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "117px" },
                                attrs: {
                                  no: "40",
                                  value: _vm.truckingInfo.truckingFee,
                                  disabled: _vm.readonly,
                                  min: 0,
                                  max: 999999999999,
                                  precision: 2,
                                  "controls-position": "right"
                                },
                                on: {
                                  input: function(value) {
                                    _vm.truckingFeeCharge(value || 0)
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                staticStyle: {
                                  width: "74px",
                                  "margin-left": "5px"
                                },
                                attrs: {
                                  no: "currency",
                                  disabled: _vm.readonly,
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Currency,
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.truckingInfo.currency
                                },
                                on: { parentCallBack: _vm.onCurrencyChange }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.DestinationPortAdditionalFee"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "destinationPortAdditionalFee",
                              disabled: _vm.readonly,
                              type: "textarea",
                              rows: 3
                            },
                            model: {
                              value:
                                _vm.truckingInfo.destinationPortAdditionalFee,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.truckingInfo,
                                  "destinationPortAdditionalFee",
                                  $$v
                                )
                              },
                              expression:
                                "truckingInfo.destinationPortAdditionalFee"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { label: _vm.$t("SeaExport.Tel") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: { no: "41", disabled: _vm.readonly },
                                on: { change: _vm.refreshTopGrid },
                                model: {
                                  value: _vm.truckingInfo.driverTel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.truckingInfo, "driverTel", $$v)
                                  },
                                  expression: "truckingInfo.driverTel"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("CargoMsg.ActualDeliveryDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actLoadingDate",
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "42",
                              disabled: _vm.readonly,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actLoadingDate",
                                  null,
                                  true,
                                  true,
                                  _vm.truckingInfo
                                )
                              }
                            },
                            model: {
                              value: _vm.truckingInfo.actLoadingDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.truckingInfo,
                                  "actLoadingDate",
                                  $$v
                                )
                              },
                              expression: "truckingInfo.actLoadingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.PlateNumber") }
                        },
                        [
                          _vm.isEdit
                            ? _c("el-input", {
                                staticStyle: { width: "280px" },
                                attrs: { no: "43" },
                                on: {
                                  input: function(val) {
                                    _vm.truckingInfo.plateNumber = val.trim()
                                  }
                                },
                                model: {
                                  value: _vm.truckingInfo.plateNumber,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.truckingInfo,
                                      "plateNumber",
                                      $$v
                                    )
                                  },
                                  expression: "truckingInfo.plateNumber"
                                }
                              })
                            : _vm._e(),
                          _vm.readonly
                            ? _c("span", { staticClass: "plate_number" }, [
                                _vm._v(_vm._s(_vm.truckingInfo.plateNumber))
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: {
                                label: _vm.$t("Warehouse.DriverPhone"),
                                disabled: _vm.txtEditEable
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: { no: "45", disabled: _vm.readonly },
                                model: {
                                  value: _vm.truckingInfo.driverPhone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.truckingInfo,
                                      "driverPhone",
                                      $$v
                                    )
                                  },
                                  expression: "truckingInfo.driverPhone"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.Door") }
                        },
                        [
                          _c("cargo-repeat-value-select", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                              filterable: "",
                              "allow-create": true,
                              disabled: _vm.readonly,
                              clearable: "",
                              options: _vm.doorList,
                              "label-field": "name",
                              "value-field": "name",
                              "unique-field": "uuid",
                              "match-of-repeat-value": _vm.matchOfRepeatDoor
                            },
                            on: { change: _vm.doorsChangeHandler },
                            model: {
                              value: _vm.truckingInfo.doorName,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorName", $$v)
                              },
                              expression: "truckingInfo.doorName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.Tel") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { no: "46", disabled: _vm.readonly },
                            model: {
                              value: _vm.truckingInfo.doorManTel,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                              },
                              expression: "truckingInfo.doorManTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AdditionalNotes") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "47",
                              disabled: _vm.readonly,
                              "filter-chars": false,
                              type: "textarea",
                              rows: 3
                            },
                            model: {
                              value: _vm.truckingInfo.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "remarks", $$v)
                              },
                              expression: "truckingInfo.remarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.DischargingWay") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: {
                                value: _vm.truckingInfo.dischargingWay
                                  ? _vm.truckingInfo.dischargingWay.split(",")
                                  : [],
                                no: "48",
                                disabled: _vm.readonly,
                                multiple: ""
                              },
                              on: {
                                input: function(value) {
                                  _vm.truckingInfo.dischargingWay = value.join(
                                    ","
                                  )
                                }
                              }
                            },
                            [
                              _c("el-option", { attrs: { value: "DROP" } }),
                              _c("el-option", {
                                attrs: { value: "LIVE UNLOAD" }
                              }),
                              _c("el-option", {
                                attrs: { value: "EXCHANGE PALLETS" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.LatestDeliveryDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actDeliveryDate",
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "actDeliveryDate",
                              disabled: _vm.readonly,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actDeliveryDate",
                                  null,
                                  true,
                                  true,
                                  _vm.truckingInfo
                                )
                              }
                            },
                            model: {
                              value: _vm.truckingInfo.actDeliveryDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.truckingInfo,
                                  "actDeliveryDate",
                                  $$v
                                )
                              },
                              expression: "truckingInfo.actDeliveryDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("RailwayExport.EQQuantity") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              type: "text",
                              no: "61",
                              disabled: _vm.readonly
                            },
                            on: {
                              input: function($event) {
                                _vm.truckingInfo.boxesNumber = _vm.truckingInfo.boxesNumber.replace(
                                  /[^0-9]/g,
                                  ""
                                )
                              }
                            },
                            model: {
                              value: _vm.truckingInfo.boxesNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "boxesNumber", $$v)
                              },
                              expression: "truckingInfo.boxesNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pageSource !== "remoteBooking",
                  expression: "pageSource !== 'remoteBooking'"
                }
              ]
            },
            [
              !_vm.isMaster
                ? _c("div", { staticClass: "app-main-inner-row operations" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cooperateEdit,
                            expression: "cooperateEdit"
                          }
                        ],
                        staticClass: "triggers"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "48",
                                  type: "primary",
                                  disabled: !_vm.linkUsageEnable
                                },
                                on: { click: _vm.linkUsageClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AddPackingInfo"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "49",
                                  type: "danger",
                                  disabled: !_vm.linkUsageEnable
                                },
                                on: { click: _vm.delLinkUsageClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.RemovePackingInfo"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticStyle: { "flex-grow": "1", padding: "10px" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      no: "52",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.usages
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("discharging-trucking-container-usage-link-dialog", {
        attrs: {
          visible: _vm.containerUsageDialog.visible,
          "job-uuid": _vm.job.uuid,
          "trucking-info-uuid": _vm.truckingInfo.uuid,
          "serial-nos": _vm.containerUsageDialog.serialNos
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerUsageDialog, "visible", $event)
          },
          selectContainerUsageHandler: _vm.selectContainerUsageHandler
        }
      }),
      _c("upload-common-file", {
        attrs: {
          visible: _vm.uploadCommonFileDialog.visible,
          model: _vm.uploadCommonFileDialog.model
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadCommonFileDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }